import { all, fork } from 'redux-saga/effects';

//public
import AuthSaga from './auth/login/saga';
import ForgetSaga from './auth/forgetpwd/saga';
import ResetSaga from './auth/resetpwd/saga';
import LayoutSaga from './layout/saga';
//private
import ProfileSaga from './profile/saga';
// import usersSaga from './users/saga';
import deptSaga from './departments/saga';
import lostOrdersSaga from './lostOrders/saga';
import customerServiceSaga from './customerService/saga';
import transfersSaga from './transfers/saga';
import calculatorSaga from './calculator/saga';
import pricesSaga from './priceList/saga';
import meetingSaga from './meeting/saga';
import battleSaga from './battlefield/saga';
import prioritySaga from './priority/saga';
import statsSaga from './stats/saga';
import purchasesSaga from './purchases/saga';
import dashboardSaga from './dashboard/saga';
import actShippingSaga from './actShipping/saga';
import domainsSaga from './domains/saga';

export default function* rootSaga() {
  yield all([
    //public
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ResetSaga),
    fork(LayoutSaga),
    //private
    fork(ProfileSaga),
    // fork(usersSaga),
    fork(deptSaga),
    fork(lostOrdersSaga),
    fork(customerServiceSaga),
    fork(transfersSaga),
    fork(calculatorSaga),
    fork(pricesSaga),
    fork(meetingSaga),
    fork(battleSaga),
    fork(prioritySaga),
    fork(statsSaga),
    fork(purchasesSaga),
    fork(dashboardSaga),
    fork(actShippingSaga),
    fork(domainsSaga)
  ]);
}
